import { getErrorFromErrorResponse, isErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class GetVaultUsers {
    constructor(vaultUsersServer, cache) {
        this.vaultUsersServer = vaultUsersServer;
        this.cache = cache;
    }
    async execute(params) {
        if (params.readFromCache) {
            const cachedUsers = this.cache.get(params.sharedVaultUuid);
            if (cachedUsers) {
                return Result.ok(cachedUsers);
            }
        }
        const response = await this.vaultUsersServer.getSharedVaultUsers({ sharedVaultUuid: params.sharedVaultUuid });
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        this.cache.set(params.sharedVaultUuid, response.data.users);
        return Result.ok(response.data.users);
    }
}
